import { render } from "./Part.vue?vue&type=template&id=523c80f4&scoped=true"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"

import "./Part.vue?vue&type=style&index=0&id=523c80f4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-523c80f4"

export default script